import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRightCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 19.674 19.674",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		"data-name": "arrow-right-circle",
		children: /* @__PURE__ */ _jsxs("g", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			"data-name": "Group 1371",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 9.837,
					cy: 9.837,
					r: 9.087,
					"data-name": "Ellipse 224"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m9.6 6.332 3.5 3.505-3.5 3.505",
					"data-name": "Path 4282"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.103 9.837h-7.69",
					"data-name": "Line 536"
				})
			]
		})
	})
});
export { SvgArrowRightCircle as ReactComponent };
